<template>
  <div class="d-flex justify-space-between align-center">
    <div>
      {{ $t(def) }}
    </div>
    <div>
      <v-switch
        v-model="model[def.name]"
        v-bind="$attrs"
        :true-value="trueValue"
        :false-value="falseValue"
        inset
        v-on="$listeners"
      ></v-switch>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSwitch",
  props: ["def", "model", "items"],
  computed: {
    trueValue() {
      const item = this.items.find(item => (item.ID).toString().endsWith('1'));
      return item?.ID;
    },
    falseValue() {
      const item = this.items.find(item => (item.ID).toString().endsWith('2'));
      return item?.ID;
    }
  },
};
</script>
